import Panel from '../../../common/layout/Panel'
import DataResource from '../../../common/v4/DataResource';

const InvoiceTemplatesList = () => {
    const data = {
        url: '/admin/settings/invoice_templates',
        data: {
            data: [],
            metadata: []
        },
        userFilterExpandable: false,
        onclick: 'link',
        link: '/settings/invoice_templates/{id}',
        metadata: [
            {
                source: 'id',
                label: 'Invoice Template ID',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                source: 'name',
                label: 'Name',
                type: 'text',
            },
            {
                source: 'description',
                label: 'Description',
                type: 'text',
            },
            {
                source: 'template',
                label: 'Template Type',
                type: 'text',
            },
            {
                source: 'include_link_to_usage',
                label: 'Include Link to Usage',
                type: 'boolean',
            },
            {
                type: 'delete',
                label: 'Delete',
            }
        ]
    }
    return (
       <Panel title = "Invoice Templates">
            <DataResource
                addButtonText = "Create Invoice Template"
                addButtonLink = "/settings/invoice_templates/create"                    
                data = {data}

            />
        </Panel>
    )
}

export default InvoiceTemplatesList;